import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { IMyDpOptions } from 'mydatepicker';
import { formatDate } from '../../common/Utilities/date-utilities';

import { CommonService } from '../../common/services/common.service';
import { RegistrationService } from './registration.service';
import { LoginService } from '../login/login.service';
import { UserResponse } from '../../models/userdetails';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  @Output() onLoginNav: EventEmitter<any> = new EventEmitter <any> ();
  myDatePickerOptions: IMyDpOptions;
  registerRequestObject = {
    'Name': '',
    'Surname': '',
    'DOB': '',
    'Email': '',
    'Password': '',
    'Mobile': ''
  };
  confirmationPwd = '';
  dob: any;
  errorMap = new Map();
  invalidRegMessage = null;

  constructor(public _commonService: CommonService, private _registrationService: RegistrationService,
              private _loginService: LoginService, private _router: Router) { }

  ngOnInit() {
    // this._commonService.loadScript();
    this.myDatePickerOptions = Object.assign({}, this._commonService.myDatePickerOptions);
    this.limitDobDate();
  }

  validateMobileNumber() {
    this.registerRequestObject.Mobile = this.removeZerosinPhone(this.registerRequestObject.Mobile);
  }

  removeZerosinPhone(value:string){
    return value.replace(/^[0|\D]*/,'0');
  }

  limitDobDate() {
    const nextDate =  new Date();
    nextDate.setDate(nextDate.getDate() + 1);
    this.myDatePickerOptions.disableSince = { day: nextDate.getDate(), month: nextDate.getMonth() + 1,
                                                year: nextDate.getFullYear() };
  }

  onDateChange(event) {
    this.registerRequestObject.DOB = formatDate(event);
  }

  validateRegnDetails() {
    this.errorMap.clear();
    for (const [key, value] of Object.entries(this.registerRequestObject)) {
      if (!value) { this.errorMap.set(key, true); }
    }
    if (this.registerRequestObject.Password !== this.confirmationPwd) { this.errorMap.set('confirmPwd', true); }
    if (this.errorMap.size <= 0) { this.registerUser(); }
  }

  registerUser() {
    this.invalidRegMessage = null;
    this._registrationService.registerUser(this.registerRequestObject).subscribe((response: UserResponse) => {
      if(response.status == true && response.message == "success"){
        this.setLogin(response);
        document.getElementById('login-register-modal-close-btn').click();
      }else{
        this.invalidRegMessage = response.message;
      }
    
    });
  }

  setLogin(response:UserResponse){
    this._commonService.isLoggedIn.next(true);
    this._commonService.setUserDetails(response.data);
    localStorage.setItem('isLogged', 'true');
    localStorage.setItem('userDetails',JSON.stringify(response.data));
  }

  // loginAfterRegistration(email, password) {
  //   this._loginService.login(email, password).subscribe((response: any) => {
  //     if (response.body.message === 'success' && response.body.status) {
  //       this._commonService.isLoggedIn.next(true);
  //       localStorage.setItem('isLogged', 'true');
  //       localStorage.setItem('userName', response.body.data.name);
  //       localStorage.setItem('userId', response.body.data.id);
  //       this._commonService.userName.next(response.body.data.name);
  //       document.getElementById('login-register-modal-close-btn').click();
  //       // this._router.navigate(['/ticketvoordeel/booking/home']);
  //     }
  //   });
  // }

  goToLogin() {
    this.onLoginNav.emit(false);
  }
}
